function BreadcrumbsProfileController($scope, navigationService) {
  $scope.$watchCollection(() => navigationService.breadcrumbs, () => {
    $scope.breadcrumbs = navigationService.breadcrumbs;
  });
}

const controllerArray = [
  '$scope',
  'navigationService',
  BreadcrumbsProfileController
];

export default function (ngModule) {
  ngModule.controller('BreadcrumbsProfileController', controllerArray);
}
